<template>
  <div id="after-payment">
    <div id="after-payment-container">
      <template v-if="status=='COMPLETED'">
        <div class="success-page after-payment-container">
          <div class="status-title">Gratulacje!</div>
          <div class="status-line">Twoja płatność przebiegła pomyślnie.<br>Witaj w gronie dietetyków.</div>
          <div class="status-subline">Skorzystaj z <a href="https://kcalmar.com/dietetyk/"><span>Kcalmar</span><span>.pro</span></a></div>
          <div class="buttons">
            <a href="https://app.kcalmar.com/dashboard"><span class="button button-green">Przejdź do panelu</span></a>
          </div>
        </div>
      </template>
      <template v-else-if="status=='CANCELED'">
        <div class="error-page after-payment-container">
          <div class="status-title">Ups...</div>
          <div class="status-line">Twoja płatność nie powiodła się.</div>
          <div class="status-subline">Nic straconego.</div>
          <div>
            <a href="#"><span class="button button-white">Wsparcie konsultanta</span></a>
            <a href="https://kcalmar.com/platnosci/"><span class="button button-green">Spróbuj ponownie</span></a>
          </div>
        </div>
      </template>
      <template v-else-if="status=='ALL_INSTALLMENTS_PAID'">
        <div class="success-page after-payment-container">
          <div class="status-title">Gratulacje!</div>
          <div class="status-line">Wszystkie raty za dane zamówienie zostały opłacone.</div>
          <div class="status-subline">Skorzystaj z <a href="https://kcalmar.com/dietetyk/"><span>Kcalmar</span><span>.pro</span></a></div>
          <div class="buttons">
            <a href="https://app.kcalmar.com/dashboard"><span class="button button-green">Przejdź do panelu</span></a>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="success-page after-payment-container">
          <div class="status-title">Witaj!</div>
          <div class="status-line">Twoja płatność jest w trakcie weryfikacji.</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AfterPayment',
  data: function () {
    return {
      status: 'PENDING'
    }
  },
  mounted: function () {
    let component = this
    const delayTime = 4000
    const url = process.env.VUE_APP_PAYMENTS_SERVICE_HOST + process.env.VUE_APP_PAYMENTS_SERVICE_CHECK_PAYMENT_STATUS_PATH
    const headers = {
      'Content-Type': 'application/json'
    }
    const body = JSON.stringify({ order_id: this.$route.params.orderId })
    const checkStatusInternalId = setInterval(function () {
      fetch(
        url,
        {
          method: 'POST',
          headers: headers,
          body: body
        }
      )
        .then((res) => res.json())
        .then((data) => {
          component.status = data.payment_status
          if (component.status === 'COMPLETED') {
            window.dataLayer.push({
              'event': 'transaction',
              'order_id': data.order_id,
              'value': data.value,
              'currency': 'PLN'
            })
          }
          if (component.status !== 'PENDING') {
            clearInterval(checkStatusInternalId)
          }
        })
    }, delayTime)
  }
}
</script>

<style scoped>
#after-payment {
  font-family: 'Roboto-Regular';
  margin: auto;
  padding: 40px 0 0 0;
  text-align: center;
  max-width: 705px;
}
#after-payment-container {
  width: 100%
}
.status-title {
  border-bottom: 1px solid #E6E6E6;
  font-size: 35px;
  font-weight: 700;
  margin-bottom: 40px;
  padding: 140px 0 40px 0;
}
.success-page .status-title {
  background: url(../../assets/img/common/Kcalmar_success.png) center top no-repeat;
  color: #41CDA8;
}
.error-page .status-title {
  background: url(../../assets/img/common/Kcalmar_error.png) center top no-repeat;
  color: #E90855;
}
.status-line {
  color: #000000;
  font-size: 22px;
  margin-bottom: 30px;
}
.status-subline {
  margin-bottom: 20px;
}
.status-subline span:nth-child(1) {
  color: #000000;
  font-weight: 700;
}
.status-subline span:nth-child(2) {
  color: #E90855;
  font-weight: 700;
}
.button {
  border-radius: 5px;
  font-size: 15px;
  font-weight: 700;
  margin: 0 15px 20px 15px;
  padding: 22px 45px;
  text-transform: uppercase;
}
.button-green {
  background-color: #41CDA8;
  border: 2px solid #41CDA8;
  box-shadow: 0 5px 10px 0 rgba(48,156,128,0.4);
  color: #FFFFFF;
}
.button-white {
  background-color: #ffffff;
  border: 2px solid #41CDA8;
  box-shadow: 0 5px 10px 0 rgba(48,156,128,0.4);
  color: #41CDA8;
}
</style>
